import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { CheckoutAddressCardDTO, CheckoutCustomerFormInput, PaymentProvider, ShippingMethodId } from "@biosany/shared"
import type { RootState } from "../index"

export interface CheckoutDraftState {
	email: string
	emailLocked: boolean
	emailResolved: boolean
	form: CheckoutCustomerFormInput | null
	/** Direcciones guardadas del cliente verificado (picker); vacío = solo form nuevo. */
	savedAddresses: CheckoutAddressCardDTO[]
	/** null = "Agregar nueva dirección" seleccionada en el picker. */
	selectedAddressId: string | null
}

const emptyForm = (): CheckoutCustomerFormInput => ({
	name: "",
	phone: "",
	address: {
		line1: "",
		line2: "",
		city: "",
		state: "" as CheckoutCustomerFormInput["address"]["state"],
		zip: "",
		country: "MX"
	},
	shippingMethod: "ordinario" as ShippingMethodId,
	paymentProvider: "stripe" as PaymentProvider
})

const initialState: CheckoutDraftState = {
	email: "",
	emailLocked: false,
	emailResolved: false,
	form: null,
	savedAddresses: [],
	selectedAddressId: null
}

export const checkoutDraftSlice = createSlice({
	name: "checkoutDraft",
	initialState,
	reducers: {
		setCheckoutEmail(state, action: PayloadAction<string>) {
			state.email = action.payload
		},
		setCheckoutEmailGate(state, action: PayloadAction<{ emailLocked: boolean; emailResolved: boolean; email?: string }>) {
			state.emailLocked = action.payload.emailLocked
			state.emailResolved = action.payload.emailResolved
			if (action.payload.email !== undefined) state.email = action.payload.email
		},
		setCheckoutDraftForm(state, action: PayloadAction<CheckoutCustomerFormInput>) {
			state.form = action.payload
		},
		setCheckoutAddresses(
			state,
			action: PayloadAction<{ savedAddresses: CheckoutAddressCardDTO[]; selectedAddressId: string | null }>
		) {
			state.savedAddresses = action.payload.savedAddresses
			state.selectedAddressId = action.payload.selectedAddressId
		},
		clearCheckoutDraft() {
			return initialState
		},
		resetCheckoutEmailGate(state) {
			state.emailLocked = false
			state.emailResolved = false
			state.form = null
			state.savedAddresses = []
			state.selectedAddressId = null
		}
	}
})

export const {
	setCheckoutEmail,
	setCheckoutEmailGate,
	setCheckoutDraftForm,
	setCheckoutAddresses,
	clearCheckoutDraft,
	resetCheckoutEmailGate
} = checkoutDraftSlice.actions

export default checkoutDraftSlice.reducer

export const selectCheckoutDraft = (state: RootState): CheckoutDraftState => state.checkoutDraft

export function getEmptyCheckoutForm(): CheckoutCustomerFormInput {
	return emptyForm()
}
